import { useContext } from "react";
import { TenantContext } from "./TenantProvider";

/**
 * The single app-wide tenant brand — host/URL before login, the JWT tenant once
 * logged in (xepp for the BPS admin). Replaces useGlobalTenant / useLocalTenant.
 */
export const useTenant = () => useContext(TenantContext);
